/** Hue/saturation sampled from the baked art; lightness is irrelevant — the `color` blend keeps the hull's shading. */
export const TEAM_SPRITE_COLORS = ['#5052AF', '#CC3347', '#33CC33'] as const;

export const BASE_SPRITE_DARKEN = 0.1;
